export const routeNames = {
  customer360: '/customer360',
  proposalForm: 'proposal-form',
  claimProposalForm: 'claim-proposal-form',
  consentForm: 'consent-form/:id',
  endorse: 'endorse',
  trackRequest: 'track-request',
  paymentSelection: 'payment-selection',
  claim: 'claim',
  renewal: 'renewal',
  claimConsentForm: 'claim/consent-form/:id',

  cancellation: 'cancellation',
  proposalCancel: 'proposal-form-cancellation',
  grievance: 'grievance',
  grievanceForm: 'proposal-grievance-form',
  surrender: 'surrender',
  surrenderForm: 'proposal-surrender-form',
}
